import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { getActionButtonStyles } from '../styles/bubbleStyles';

export interface MessageAction {
  icon: LucideIcon;
  onClick: () => void;
  title: string;
  activeIcon?: LucideIcon;
  isActive?: boolean;
  iconSize?: number;
  activeColor?: string;
}

interface MessageActionsProps {
  actions: MessageAction[];
  className?: string;
}

export const MessageActions: React.FC<MessageActionsProps> = ({
  actions,
  className = '',
}) => {
  return (
    <div className={className}>
      {actions.map((action, index) => {
        const Icon =
          action.isActive && action.activeIcon
            ? action.activeIcon
            : action.icon;
        const iconSize = action.iconSize ?? 3;

        return (
          <button
            key={index}
            type="button"
            onClick={action.onClick}
            className={getActionButtonStyles()}
            title={action.title}
          >
            <Icon
              className={`h-${iconSize} w-${iconSize} ${
                action.isActive && action.activeColor
                  ? action.activeColor
                  : 'text-muted-foreground'
              }`}
            />
          </button>
        );
      })}
    </div>
  );
};
